
import './index.css';
import App              from './components/App/App';
import reportWebVitals  from './reportWebVitals';

import AltApp           from './components/App/AltApp';
import { StrictMode }   from 'react';
import { createRoot }   from 'react-dom/client';

const testApp = process.env.REACT_APP_IPRS_TESTAPP;

const rootDomNode = document.getElementById('root');
const root        = createRoot(rootDomNode);
root.render(
    <StrictMode>
        {
            testApp ? <AltApp />: <App />
        }
    </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
